import * as n from "ramda";
import * as i from "ramda-adjunct";
import * as o from "yup";
const u = (r) => () => r, p = o.string().when(["$locale"], (r) => o.string().transform(
  (s, t) => typeof t == "string" ? t : n.propOr("", r, t)
)).default(""), a = (r = 0) => o.number().transform(
  (s, t) => isNaN(t) ? r : Number(t)
).default(r), d = (r = "") => o.string().transform((s, t) => i.isNilOrEmpty(t) ? r : t), c = (r, s) => {
  if (n.is(Object, r)) {
    const t = n.keys(r);
    if (n.isEmpty(n.without(t, s)))
      return r;
    const m = n.map((e) => c(r[e], s), t);
    return n.find((e) => !n.isNil(e), m) || null;
  }
  return null;
}, y = (r, s) => n.isNil(s) ? void 0 : s;
export {
  p as localizeSchema,
  c as lookupObject,
  u as mockTransform,
  a as numberSchema,
  d as stringSchema,
  y as trasformUndefined
};
//# sourceMappingURL=index.js.map
